/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IWebgroupSearchContainerData } from './webgroup-search-container.data';
import { IWebgroupSearchContainerProps } from './webgroup-search-container.props.autogenerated';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';

export interface IWebgroupSearchContainerViewProps extends IWebgroupSearchContainerProps<IWebgroupSearchContainerData> {
    webgroupControls?: React.ReactNode;
    webgroupSearchResults?: React.ReactNode;
    searchControlsProps?: IModuleProps;
    searchContainerProps?: IModuleProps;
}

/**
 *
 * WebgroupSearchContainer component
 * @extends {React.PureComponent<IWebgroupSearchContainerProps<IWebgroupSearchContainerData>>}
 */
class WebgroupSearchContainer extends React.PureComponent<
    IWebgroupSearchContainerProps<IWebgroupSearchContainerViewProps['data']>,
    { isLoaded: boolean }
> {
    public constructor(props: any) {
        super(props);
        this.state = { isLoaded: true };
    }

    public componentDidMount() {
        const { categories } = this.props.data;
        const isSearchDone = categories.result?.length;
        if (isSearchDone) {
            this.setState({ isLoaded: false });
        }
    }

    public render(): JSX.Element | null {
        const {
            slots: { webgroupControls, webgroupSearchResults }
        } = this.props;
        const searchControlsProps: IModuleProps = {
            moduleProps: this.props,
            className: 'search-results-controls'
        };
        const searchContainerProps: IModuleProps = {
            moduleProps: this.props,
            className: 'search-results-container'
        };
        const viewProps = {
            ...this.props,
            isLoaded: this.state.isLoaded,
            webgroupControls,
            webgroupSearchResults,
            searchControlsProps,
            searchContainerProps
        };
        return this.props.renderView(viewProps);
    }
}

export default WebgroupSearchContainer;
